import { render, staticRenderFns } from "./generate_report.vue?vue&type=template&id=1487a60d&scoped=true"
import script from "./generate_report.vue?vue&type=script&lang=js"
export * from "./generate_report.vue?vue&type=script&lang=js"
import style0 from "./generate_report.vue?vue&type=style&index=0&id=1487a60d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1487a60d",
  null
  
)

export default component.exports